import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importar traducciones
import esTranslations from '../locales/es.json';
import enTranslations from '../locales/en.json';
import frTranslations from '../locales/fr.json';
import deTranslations from '../locales/de.json';

const resources = {
  es: { translation: esTranslations },
  en: { translation: enTranslations },
  fr: { translation: frTranslations },
  de: { translation: deTranslations }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es', // idioma inicial
    fallbackLng: 'es', // idioma de respaldo
    interpolation: {
      escapeValue: false // React ya escapa por seguridad
    },
    debug: false, // cambiar a true para debugging de i18n
    react: {
      useSuspense: false // para evitar problemas con lazy loading
    }
  });

export default i18n;
